import { S } from './History.style';

export const History = () => (
  <S.Container>
    <S.Inner>
      <div className="flex-column gap-48 browser-space-between w-100per">
        <S.Title>History</S.Title>
      </div>

      <S.HistoryBox>
        <S.YearWrapper>
          <div>2025</div>
          <S.MonthContainer>
            <S.MonthWrapper>
              <div>08</div>
              <S.MonthBox>
                <S.Content>
                  국토연구원, 2025 부동산서비스산업 창업경진대회 본상 수상
                </S.Content>
              </S.MonthBox>
            </S.MonthWrapper>
            <S.MonthWrapper>
              <div>07</div>
              <S.MonthBox>
                <S.Content>
                  금융위/금감원 주관 『제7회 금융회사-핀테크 기업 상호만남
                  행사』 위탁 테스트 발표기업 선정
                </S.Content>
                <S.Content>
                  조선일보 땅집고(주식회사 엠딕) SI 투자 유치 완료
                </S.Content>
                <S.Content>
                  김기현 대표, 신약개발연구조합 'AI신약개발 전략교육 과정'
                  심화과정 강의
                </S.Content>
              </S.MonthBox>
            </S.MonthWrapper>
            <S.MonthWrapper>
              <div>06</div>
              <S.MonthBox>
                <S.Content>
                  2025 KB 스타터스+KB Futures 9기 선정 (KB 금융그룹
                  오픈이노베이션)
                </S.Content>
                <S.Content>
                  노동부 25년 사업장 HR플랫폼 이용지원 사업 선정
                </S.Content>
                <S.Content>서울시 매력일자리 인턴 채용기업 선정</S.Content>
                <S.Content>
                  [국내과정] 2025년 ICT 학점연계 프로젝트 인턴십 하반기 연수업체
                  선정
                </S.Content>
                <S.Content>
                  2025 서울창업허브 공덕 상반기 입주기업 선정
                </S.Content>
                <S.Content>
                  2025 서울 오픈이노베이션 스케일업 데이 - IR 기업 선정
                </S.Content>
                <S.Content>㈜바른NPL, MOU 및 사업제휴 협약</S.Content>
                <S.Content>
                  서초구, 2025년 고성능 컴퓨팅인프라 지원사업 기업 선정
                </S.Content>
                <S.Content>
                  2025년 LS엠트론 「오픈이노베이션 협력사업」 선정 - 신사업 추진
                </S.Content>
                <S.Content>
                  과기부, 2025년도 SaaS 전환 컨설팅 수요기업 선정
                </S.Content>
              </S.MonthBox>
            </S.MonthWrapper>
            <S.MonthWrapper>
              <div>05</div>
              <S.MonthBox>
                <S.Content>
                  [NAVER Cloud] 밋업 기업 선정 - 오픈이노베이션
                </S.Content>
                <S.Content>
                  2025년 DGB금융그룹 피움랩 7기 선정 - iM뱅크(구 대구은행),
                  iM캐피탈 협력사업 추진
                </S.Content>
                <S.Content>한국언론재단, 2025 미디어 스타트업 선정</S.Content>
                <S.Content>
                  과학기술정보통신부, 소프트웨어 사업자 승인
                </S.Content>
              </S.MonthBox>
            </S.MonthWrapper>
            <S.MonthWrapper>
              <div>04</div>
              <S.MonthBox>
                <S.Content>2025년 재도전성공패키지 일반형 선정</S.Content>
              </S.MonthBox>
            </S.MonthWrapper>
            <S.MonthWrapper>
              <div>03</div>
              <S.MonthBox>
                <S.Content>
                  국내 최대 회계법인 부실채권 분석 빅데이터 서비스 PoC
                </S.Content>
                <S.Content>
                  조선일보 땅집고(주식회사 엠딕) 공동사업 협약, 투자유치 확약
                </S.Content>
              </S.MonthBox>
            </S.MonthWrapper>
            <S.MonthWrapper>
              <div>01</div>
              <S.MonthBox>
                <S.Content>
                  본사 강원도 이전(강원도 펀드 투자 일환), 지점/연구소 서울
                  사무소
                </S.Content>
                <S.Content>
                  AI바우처 공급기업 선정(우수기업, 2년 연속)
                </S.Content>
              </S.MonthBox>
            </S.MonthWrapper>
          </S.MonthContainer>
        </S.YearWrapper>
        <S.YearWrapper>
          <div>2024</div>
          <S.MonthContainer>
            <S.MonthWrapper>
              <div>12</div>
              <S.MonthBox>
                <S.Content>
                  트랜스파머x땅집고x한국NPL솔루션포럼 MOU 체결
                </S.Content>
              </S.MonthBox>
            </S.MonthWrapper>
            <S.MonthWrapper>
              <div>11</div>
              <S.MonthBox>
                <S.Content>특허출원 3건</S.Content>
              </S.MonthBox>
            </S.MonthWrapper>
            <S.MonthWrapper>
              <div>10</div>
              <S.MonthBox>
                <S.Content>
                  김기현 대표, 인천경제자유구역청, 청장 비전/전략 자문위원 위촉
                </S.Content>
              </S.MonthBox>
            </S.MonthWrapper>
            <S.MonthWrapper>
              <div>09</div>
              <S.MonthBox>
                <S.Content>핀스프로토콜, 블록체인 서비스 개발</S.Content>
              </S.MonthBox>
            </S.MonthWrapper>
            <S.MonthWrapper>
              <div>08</div>
              <S.MonthBox>
                <S.Content>
                  농협중앙회, NH 오픈비즈니스허브애그-푸드테크스타트업IR 장려상
                  수상
                </S.Content>
                <S.Content>카카오 for Startup Cloud Program 선정 </S.Content>
                <S.Content>Naver for Startup Cloud Program 선정</S.Content>
                <S.Content>Google for Startup Cloud Program 선정</S.Content>
              </S.MonthBox>
            </S.MonthWrapper>
            <S.MonthWrapper>
              <div>06</div>
              <S.MonthBox>
                <S.Content>
                  농협중앙회, 충북농협본부 AI부실채권 분석 플랫폼 PoC
                </S.Content>
                <S.Content>
                  중기부 TIPS 선정(R&D 자금 5억원+사업화 자금 3억원)
                </S.Content>
                <S.Content>
                  농협중앙회, 농업기술진흥원, 소풍벤처스 NharvestX 프로그램 선정
                </S.Content>
                <S.Content>
                  한국농업기술진흥원, 한국사회투자, 민간 우수기술 사업화
                  지원사업 (Agri-Future) 선정
                </S.Content>
                <S.Content>
                  한국데이터산업진흥원, 데이터바우처지원사업 선정
                </S.Content>
              </S.MonthBox>
            </S.MonthWrapper>
            <S.MonthWrapper>
              <div>05</div>
              <S.MonthBox>
                <S.Content>신용보증기금 Start-up NEST 15기 선정</S.Content>
              </S.MonthBox>
            </S.MonthWrapper>
            <S.MonthWrapper>
              <div>04</div>
              <S.MonthBox>
                <S.Content>
                  한국농업기술진흥원, 씨엔티테크, Fast Track 프로그램 선정
                </S.Content>
                <S.Content>중기부 '초기창업패키지' 사업 선정</S.Content>
                <S.Content>소셜벤처기업 인증</S.Content>
              </S.MonthBox>
            </S.MonthWrapper>
            <S.MonthWrapper>
              <div>03</div>
              <S.MonthBox>
                <S.Content>벤처기업 인증</S.Content>
              </S.MonthBox>
            </S.MonthWrapper>
            <S.MonthWrapper>
              <div>02</div>
              <S.MonthBox>
                <S.Content>소풍벤처스 Seed 투자 유치 완료</S.Content>
                <S.Content>
                  김기현 대표, 한국신약개발연구조합 유공자 공로패 수상
                </S.Content>
              </S.MonthBox>
            </S.MonthWrapper>
            <S.MonthWrapper>
              <div>01</div>
              <S.MonthBox>
                <S.Content>NH농협 디지털혁신캠퍼스 입주기업 선정</S.Content>
                <S.Content>
                  정책평가연구원, 정책 포털 빅데이터 검색 시스템 구축
                </S.Content>
                <S.Content>
                  창업진흥원, 비대면서비스 바우처 수요기업 선정
                </S.Content>
                <S.Content>AI 바우처 공급기업 선정</S.Content>
              </S.MonthBox>
            </S.MonthWrapper>
          </S.MonthContainer>
        </S.YearWrapper>
        <S.YearWrapper>
          <div>2023</div>
          <S.MonthContainer>
            <S.MonthWrapper>
              <div>12</div>
              <S.MonthBox>
                <S.Content>
                  세종대학교 스마트생명산업융합학과 교보재 제공 MOU
                </S.Content>
                <S.Content>NH농협 오픈이노베이션 후속 연계기업 선정 </S.Content>
                <S.Content>서울창조경제혁신센터 보육기업 선정 </S.Content>
              </S.MonthBox>
            </S.MonthWrapper>
            <S.MonthWrapper>
              <div>11</div>
              <S.MonthBox>
                <S.Content>데이터사업자 신고</S.Content>
              </S.MonthBox>
            </S.MonthWrapper>
            <S.MonthWrapper>
              <div>10</div>
              <S.MonthBox>
                <S.Content>
                  ICT 콤플렉스(한국정보방송통신대연합), 투자상담회 우수기업 선정
                </S.Content>
                <S.Content>
                  한국통신사업자연합회(KTOA) 벤처리움, 제4회 통신사 대상 IR
                  우수기업 선정
                </S.Content>
              </S.MonthBox>
            </S.MonthWrapper>
            <S.MonthWrapper>
              <div>09</div>
              <S.MonthBox>
                <S.Content>
                  한국부동산원, 빈집추정시스템 특허 무상사용실시권 획득
                </S.Content>
                <S.Content>특허 4건 및 상표권 1권 출원</S.Content>
                <S.Content>
                  국토교통부-공간정보산업진흥원, 공간정보 창업기업 시장성 TEST
                  지원사업 선정
                </S.Content>
                <S.Content>
                  과학기술정보통신부, 한국지능정보사회진흥원, ‘초거대 AI 활용
                  지원사업’ 선정
                </S.Content>
                <S.Content>
                  서울시 캠퍼스 타운 인재양성 사업 인턴십 참여 기업 선정
                </S.Content>
                <S.Content>김기현 대표, 정책평가연구원 기술고문 위촉</S.Content>
              </S.MonthBox>
            </S.MonthWrapper>
            <S.MonthWrapper>
              <div>08</div>
              <S.MonthBox>
                <S.Content>KOITA 기업부설연구소 설립</S.Content>
                <S.Content>정책평가연구원 정책플랫폼 용역 수주</S.Content>
              </S.MonthBox>
            </S.MonthWrapper>
            <S.MonthWrapper>
              <div>08</div>
              <S.MonthBox>
                <S.Content>KOITA 기업부설연구소 설립</S.Content>
                <S.Content>
                  정책평가연구원, 정책평가플랫폼 개발용역 수주
                </S.Content>
              </S.MonthBox>
            </S.MonthWrapper>
            <S.MonthWrapper>
              <div>06</div>
              <S.MonthBox>
                <S.Content>
                  김기현 대표, 행정안전부 K주소 해외수출 협의체 전문위원 위촉
                </S.Content>
                <S.Content>
                  김기현 대표, 행정안전부 주소미래혁신포럼 전문위원 위촉
                </S.Content>
              </S.MonthBox>
            </S.MonthWrapper>
            <S.MonthWrapper>
              <div>05</div>
              <S.MonthBox>
                <S.Content>전라남도 나주시, 트랜스파머 시범사업 진행</S.Content>
              </S.MonthBox>
            </S.MonthWrapper>
            <S.MonthWrapper>
              <div>04</div>
              <S.MonthBox>
                <S.Content>
                  한국지능정보사회진흥원 2023 빅데이터 플랫폼 기반 분석서비스
                  지원사업 선정
                </S.Content>
              </S.MonthBox>
            </S.MonthWrapper>
            <S.MonthWrapper>
              <div>03</div>
              <S.MonthBox>
                <S.Content>에이치컴바인드 주식회사 Angel 투자 유치</S.Content>
                <S.Content>법인 설립</S.Content>
              </S.MonthBox>
            </S.MonthWrapper>
          </S.MonthContainer>
        </S.YearWrapper>
      </S.HistoryBox>
    </S.Inner>
  </S.Container>
);

export default History;
